import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { DECORATOR__ui_without_component } from '../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { DECORATOR__class_serialization_tested } from '../_primitives/_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__ml_asset_vae extends FIELD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ML_ASSET_VAE;

  /*
   * STATIC METHODS
   */

  /*
   * FIELDS
   */

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.VAE)
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;

  seamless_axes!: string[];

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.ML_ASSET__VAE;
  }

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return this.model.find_source(graph).field_connectable__value(graph);
  }

  /*
   * METHODS
   */

  @DECORATOR__ui_without_component
  post_init(): void {
    super.post_init();
  }

  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = [];

    out.push('model');

    return out as string[];
  }
}
